import type { ModalNameType } from '@/modals/components/ModalProvider';
import { useSocketEvent } from '@/hooks/socket/useSocketEvent';
import { BLOCK_ACCOUNT_REASONS } from '@/libs/auth/blockAccount';
import { logoutUser } from '@/libs/auth/logoutUser';
import { tokenManager } from '@/queries/token-manager';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { checkToken } from '@/redux/slices/userSlice';

interface UserDeactivationMessage {
  userId: string;
  deactivatedAt: string;
  clientFacingDeactivateReason?: string;
}

export function useUserDeactivationSocket() {
  const userSession = useAppSelector(state => state.user.userSession);
  const dispatch = useAppDispatch();
  useSocketEvent<UserDeactivationMessage>(
    'user.deactivated',
    async (data) => {
      if (!userSession) {
        return;
      }

      const currentUserId = tokenManager.getUserId();

      if (currentUserId && data.userId === currentUserId) {
        const searchParams = new URLSearchParams({ m: 'block-account-reason' satisfies ModalNameType });
        searchParams.set('blockReason', data.clientFacingDeactivateReason ?? BLOCK_ACCOUNT_REASONS.ACCOUNT_BLOCKED);

        await logoutUser(false, true, `/?${searchParams.toString()}`);
        dispatch(checkToken());
      }
    },
    Boolean(userSession),
  );
}
